module.exports = __webpack_public_path__ + "static/img/marathon.a6fc6c67.svg";